export enum LinkType {
	internal = 'internal',
	external = 'external',
	email = 'email',
	phone = 'phone'
}
